import { render, staticRenderFns } from "./RepInscritosDep.vue?vue&type=template&id=f611e0c4&"
import script from "./RepInscritosDep.vue?vue&type=script&lang=js&"
export * from "./RepInscritosDep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports